// Result codes returned by the fax provider. "Pending" is the only non-final state:
// anything else means the provider has resolved the fax and the value will not change.
export const FaxResultCode = {
  Success: "0",
  Pending: "1000",
};

// Translation key explaining, in plain language, why a fax did not reach its destination.
// The codes are the provider's; the wording is ours, and aimed at someone who just wants to
// know whether their prescription arrived.
export function getFaxFailureMessageKey(resultCode?: string): string {
  switch (resultCode) {
    case "6100":
      return "consult.fax-failure-busy";
    case "6200":
      return "consult.fax-failure-no-answer";
    case "6300":
    case "6500":
    case "6600":
      return "consult.fax-failure-not-a-fax";
    case "6000":
    case "6400":
      return "consult.fax-failure-connect";
    case "6700":
    case "5100":
      return "consult.fax-failure-blocked";
    case "6800":
    case "7000":
    case "8000":
      return "consult.fax-failure-transmit";
    default:
      return "consult.fax-failure-generic";
  }
}
